import Vue from 'vue'
import Card from './Card'
import Child from './Child'
import Button from './Button'
import Checkbox from './Checkbox'
import SocialAuth from './SocialAuth'
import Typing from './Typing'
import {HasError, AlertError, AlertSuccess} from 'vform'

// Components that are registered globaly.
[
    Card,
    Child,
    Button,
    Checkbox,
    HasError,
    AlertError,
    AlertSuccess,
    SocialAuth,
    Typing
].forEach(Component => {
    Vue.component(Component.name, Component)
})



// WEBPACK FOOTER //
// ./src/components/index.js